<template>
    <section
        class="mt-0 z-40 relative"
        :class="{
            'lg:-mt-16': streamers && streamers.length >= 1,
            'lg:-mt-10': !streamers || streamers.length < 1,
        }"
    >
        <!-- <empty-list
            :message="message"
            v-if="message && (!streamers || streamers.length < 1)"
        ></empty-list> -->
        <div
            v-if="recording & !isStartedFromBackspace"
            class="grid gap-6 grid-cols-2 lg:grid-cols-4 items-center content-center"
        >
            <section
                v-show="showRecordButton && system_role == 'moderator'"
                class="rounded-lg shadow divide-y divide-gray-200 col-span-2 lg:col-start-2 lg:col-span-2 m-4 -mt-6"
            >
                <div
                    class="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded"
                >
                    <div class="flex">
                        <div class="flex-shrink-0">
                            <ExclamationIcon
                                class="h-5 w-5 text-yellow-400"
                                aria-hidden="true"
                            />
                        </div>

                        <div class="ml-3">
                            <p class="text-sm text-yellow-700 font-semibold">
                                {{
                                    t(
                                        "vonage.start-meeting-title",
                                        "Meeting starten?"
                                    )
                                }}
                            </p>
                            <p class="text-sm text-yellow-700">
                                {{
                                    t(
                                        "vonage.start-meeting-text",
                                        "Klik op de button hiernaast!"
                                    )
                                }}
                            </p>
                            <button
                                type="button"
                                class="inline-flex items-center px-4 mt-2 py-1 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-yellow-600 hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500"
                                @click="startMeeting()"
                            >
                                {{ t("vonage.start-meeting-button", "Start") }}
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <ul
            class="grid gap-6 grid-cols-2 lg:grid-cols-4 items-center content-center"
        >
            <li
                class="bg-indigo-500 rounded-lg shadow divide-y divide-gray-200 col-span-2 lg:col-start-2 lg:col-span-2"
            >
                <div
                    class="w-full flex items-center justify-between"
                    :class="{
                        'p-6 space-x-6':
                            streamers &&
                            streamers.length > 0 &&
                            system_role == 'moderator',
                        'p-2 space-x-2':
                            !streamers ||
                            streamers.length <= 0 ||
                            system_role != 'moderator',
                    }"
                >
                    <div class="flex-1 truncate">
                        <div
                            class="flex items-center space-x-3"
                            v-if="
                                streamers &&
                                streamers.length > 0 &&
                                system_role == 'moderator'
                            "
                        >
                            <article
                                v-for="(streamer, index) in streamers"
                                v-bind:key="index"
                            >
                                <span
                                    class="relative z-0 block shadow-sm rounded-md"
                                    v-if="
                                        streamer &&
                                        streamer.stream &&
                                        streamer.stream.connection &&
                                        streamer.stream.connection.data
                                    "
                                >
                                    <span
                                        type="button"
                                        class="relative inline-flex items-center px-4 py-2 rounded-l-md border border-gray-300 bg-white text-sm text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 font-medium"
                                    >
                                        <StatusOnlineIcon
                                            class="-ml-1 mr-2 h-5 w-5 text-green-600 animate-pulse"
                                            aria-hidden="true"
                                        />
                                        {{ streamer.stream.connection.data }}
                                    </span>
                                    <button
                                        type="button"
                                        class="-ml-px relative inline-flex items-center px-3 py-2 mt-2 rounded-r-md border border-red-300 bg-red-600 text-sm font-medium text-red-700 hover:bg-red-700 focus:z-10 focus:outline-none focus:ring-1 focus:ring-red-500 focus:border-red-500"
                                        @click="
                                            stopPublisher(
                                                streamer.stream,
                                                streamer.stream.connection
                                            )
                                        "
                                    >
                                        <StopIcon
                                            class="h-5 w-5 text-white"
                                            aria-hidden="true"
                                        />
                                    </button>
                                </span>
                            </article>
                        </div>
                        <!-- <p class="mt-1 text-gray-500 text-sm truncate">
                            Ondertitel
                        </p> -->
                    </div>
                </div>
                <div>
                    <div class="-mt-px flex divide-x divide-gray-200">
                        <div class="w-0 flex-1 flex">
                            <a
                                class="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-base text-indigo-50 font-medium border border-transparent rounded-bl-lg hover:text-gray-50 cursor-pointer"
                                @click="joinWith('webcam')"
                                :class="{
                                    'bg-indigo-800 hover:bg-indigo-700':
                                        !isPublishing ||
                                        isPublishing != 'webcam',
                                    'bg-red-800 hover:bg-red-900':
                                        isPublishing == 'webcam',
                                }"
                            >
                                <VideoCameraIcon
                                    class="w-8 h-8 text-white"
                                    aria-hidden="true"
                                />
                                <span
                                    v-if="isPublishing == 'webcam'"
                                    class="font-extrabold"
                                >
                                    <StopIcon class="h-8 w-8 text-white ml-3" />
                                </span>
                                <span
                                    class="ml-3"
                                    v-if="
                                        !isPublishing ||
                                        isPublishing != 'webcam'
                                    "
                                    >{{
                                        t("vonage.start-webcam", "Start webcam")
                                    }}</span
                                >
                            </a>
                        </div>

                        <div class="-ml-px w-0 flex-1 flex">
                            <a
                                class="relative w-0 flex-1 inline-flex items-center justify-center py-4 text-base text-indigo-50 font-medium border border-transparent rounded-br-lg hover:text-white cursor-pointer"
                                @click="joinWith('screen')"
                                :class="{
                                    'bg-indigo-800 hover:bg-indigo-700':
                                        !isPublishing ||
                                        isPublishing != 'screen',
                                    'bg-red-800 hover:bg-red-900':
                                        isPublishing == 'screen',
                                }"
                            >
                                <DesktopComputerIcon
                                    class="w-8 h-8 text-white"
                                    aria-hidden="true"
                                />

                                <span
                                    v-if="isPublishing == 'screen'"
                                    class="font-extrabold"
                                >
                                    <StopIcon class="h-8 w-8 text-white ml-3" />
                                </span>
                                <span
                                    class="ml-3"
                                    v-if="
                                        !isPublishing ||
                                        isPublishing != 'screen'
                                    "
                                    >{{
                                        t("vonage.share-screen", "Scherm delen")
                                    }}</span
                                >
                            </a>
                        </div>
                    </div>
                </div>
            </li>
        </ul>

        <div v-if="is_started || showStop" class="items-center content-center">
            <div v-if="!isStartedFromBackspace && system_role == 'moderator'">
                <button
                    v-if="meeting != 'backstage'"
                    type="button"
                    class="inline-flex items-center px-4 py-2 border border-transparent shadow-2xl text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 m-4 mt-4"
                    @click="stopMeeting()"
                >
                    <svg
                        class="-ml-1 mr-2 h-5 w-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        ></path>
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M9 10a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z"
                        ></path>
                    </svg>

                    {{ t("vonage.stop-meeting-button", "Stop") }}
                </button>
            </div>
        </div>
    </section>
</template>

<script>
import {
    ExclamationIcon,
    StatusOnlineIcon,
    StopIcon,
    VideoCameraIcon,
    DesktopComputerIcon,
} from "@heroicons/vue/solid";
import Swal from "sweetalert2";
import EmptyList from "../components/EmptyList.vue";
export default {
    components: {
        ExclamationIcon,
        EmptyList,
        StatusOnlineIcon,
        StopIcon,
        VideoCameraIcon,
        DesktopComputerIcon,
    },
    props: ["streamers", "system_role", "meeting", "is_started"],
    mounted() {
        // Eventing.listen(
        //     "changeOfOpenTokToken",
        //     (source) => (this.isPublishing = source)
        // );
        Eventing.listen(
            "resetPublishSource",
            (source) => ((this.isPublishing = source), (this.source = source))
        );

        Eventing.listen("joinWithCam", () => this.startFromBackstage("webcam"));

        Eventing.listen("streamsFromBackstage", () =>
            this.setStreamingActive()
        );

        Eventing.listen("recordingStarted", () => (this.recording = false));

        this.recording =
            document.head.querySelector('meta[name="auto_record"]').content ==
            "true"
                ? false
                : true;

        if (this.is_started != null) {
            this.recording = false;
        }
        // this.message = {{ t('vonage.share-screen', 'Scherm delen') }}
    },
    created() {
        if (this.is_started != null) {
            this.recording = false;
        }
    },
    data() {
        return {
            message:
                "<b>Geen uitzenders</b><br>Momenteel wordt er niet uitgezonden in deze vergadering.",
            isPublishing: false,
            source: null,
            busy: false,
            recording: true,
            showRecordButton: false,
            showStop: false,
            isStartedFromBackspace: false,
        };
    },
    methods: {
        joinWith(source) {
            let self = this;
            this.busy = true;
            if (source != this.source) {
                Eventing.fire("forcedSoftUnpublish");
                Eventing.fire("publishRequest", source);
                this.source = source;
                setTimeout(() => {
                    self.showRecordButton = true;
                }, 2500);
            } else if (this.source && source == this.source) {
                Eventing.fire("forcedSoftUnpublish");
                this.source = null;
                this.isPublishing = false;
                window.location.reload();
            }
        },
        setStreamingActive() {
            this.isPublishing = "webcam";
        },
        startFromBackstage(source) {
            let self = this;
            this.busy = true;
            if (source != this.source) {
                Eventing.fire("forcedSoftUnpublish");
                Eventing.fire("publishRequest", source);
                this.source = source;
            } else if (this.source && source == this.source) {
                Eventing.fire("forcedSoftUnpublish");
                this.source = null;
                this.isPublishing = false;
                window.location.reload();
            }
            this.isStartedFromBackspace = true;
        },
        stopMeeting() {
            let self = this;
            Swal.fire({
                title: self.t(
                    "vonage.stop-meeting-confirm-title",
                    "Stop meeting"
                ),
                text: self.t(
                    "vonage.stop-meeting-confirm-text",
                    "Zeker weten?"
                ),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#de3618",
                cancelButtonColor: "#333",
                confirmButtonText: self.t("tts.yes"),
                cancelButtonText: self.t("tts.cancel"),
            }).then((result) => {
                if (result.value) {
                    axios
                        .get(
                            "/api/meetings/" +
                                self.meeting +
                                "?stop=" +
                                self.t(
                                    "vonage.meeting-stopped-chat",
                                    "De vergadering is gesloten"
                                )
                        )
                        .then((response) => {
                            console.info(response.data);
                            Eventing.fire("notify", {
                                message: "",
                                title: self.t(
                                    "vonage.stop-meeting-success",
                                    "Vergadering gesloten"
                                ),
                                type: "success",
                            });
                            Eventing.fire("stopSession");
                            self.recording = false;
                        })
                        .catch((error) => {
                            Eventing.fire("notify", {
                                title: "Error",
                                message: self.t(
                                    "vonage.stop-meeting-failure",
                                    "Opname stoppen mislukt"
                                ),
                                type: "error",
                            });
                        });
                }
            });
        },
        startMeeting() {
            let self = this;
            Swal.fire({
                title: self.t(
                    "vonage.start-meeting-confirm-title",
                    "Start meeting"
                ),
                text: self.t(
                    "vonage.start-meeting-confirm-text",
                    "Zeker weten?"
                ),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#de3618",
                cancelButtonColor: "#333",
                confirmButtonText: self.t("tts.yes"),
                cancelButtonText: self.t("tts.cancel"),
            }).then((result) => {
                if (result.value) {
                    axios
                        .get(
                            "/api/meetings/" +
                                self.meeting +
                                "?record=" +
                                self.t(
                                    "vonage.meeting-started-chat",
                                    "De vergadering is geopend"
                                )
                        )
                        .then((response) => {
                            console.info(response.data);
                            Eventing.fire("notify", {
                                message: "",
                                title: self.t(
                                    "vonage.start-meeting-success",
                                    "Opname wordt gestart"
                                ),
                                type: "success",
                            });
                            self.recording = false;
                            self.showStop = true;
                        })
                        .catch((error) => {
                            Eventing.fire("notify", {
                                title: "Error",
                                message: self.t(
                                    "vonage.start-meeting-failure",
                                    "Opname starten mislukt"
                                ),
                                type: "error",
                            });
                        });
                }
            });
        },
        stopPublisher(stream, connection) {
            let self = this;
            Swal.fire({
                title: "Stop Publisher?",
                text: "",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#de3618",
                cancelButtonColor: "#333",
                confirmButtonText: self.t("tts.yes"),
                cancelButtonText: self.t("tts.cancel"),
            }).then((result) => {
                if (result.value) {
                    Eventing.fire("stoppingPublisher", stream, connection);
                }
            });
        },
    },
};
</script>
